import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from'../Component/Header'
const Fees = () => { 
  useEffect(() => {
    document.title = ' Fees - Sacread Heart Kharagpur';  
}, []); 
  return (
     <>
     <Header/>
       <div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  Academic</li>
                 <li>Fees</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1>Fees</h1>
                    </div>
                </div>
                <div className="row">
                     <div className="col-12">
                     <div className="table-responsive maintable">
                     <table class="table">
                     <tbody>
                     <tr>
                            <th> Particulars </th>
                            <th colspan="4"> Amount Rs.</th>
                          </tr>
                          <tr>
                            <td> <b>Admission Fee (New)</b></td>
                            <td colspan="4"> 15,000.00 </td>
                          </tr>
                          <tr>
                              <td> Primary to High School </td>
                              <td colspan="4"> 3000.00 </td>
                          </tr> 
                          <tr>
                          <th>   </th>
                          <th> V-X</th>
                          <th colspan="4"> XI - XII </th>
                        </tr>
                        <tr>
                          <td><b>Tuition Fees</b></td>
                          <td>3200.00 </td>
                          <td colspan="4"> 3200.00 </td>
                        </tr>
                        <tr>
                          <td> <b>Audio Visual Fees</b> </td>
                          <td> 150.00 </td>
                          <td colspan="4"> 150.00 </td>
                        </tr>
                          <tr>
                            <th>Annual Fees</th>
                            <th>V-VIII</th>
                            <th>IX-X (With Comp)</th>
                            <th>IX-X (Without Comp)</th>
                            <th>XI-XII</th>
                          </tr>  
                          <tr>
                            <td>Library</td>
                            <td>100.00</td>
                            <td>100.00</td>
                            <td>100.00</td>
                            <td>100.00</td>
                          </tr>
                          <tr>
                            <td>Games/Sports</td>
                            <td>300.00</td>
                            <td>300.00</td>
                            <td>300.00</td>
                            <td>300.00</td>
                          </tr>
                          <tr>
                            <td>Electricity/Tele</td>
                            <td>800.00</td>
                            <td>800.00</td>
                            <td>800.00</td>
                            <td>800.00</td>
                          </tr>
                          <tr>
                            <td>Co-curricular Activity</td>
                            <td>800.00</td>
                            <td>800.00</td>
                            <td>800.00</td>
                            <td>800.00</td>
                          </tr>
                          <tr>
                            <td>Examination</td>
                            <td>400.00</td>
                            <td>400.00</td>
                            <td>400.00</td>
                            <td>400.00</td>
                          </tr>
                          <tr>
                            <td>Building Fund</td>
                            <td>300.00</td>
                            <td>300.00</td>
                            <td>300.00</td>
                            <td>300.00</td>
                          </tr>
                          <tr>
                            <td>Miscellaneous</td>
                            <td>1100.00</td>
                            <td>1100.00</td>
                            <td>1100.00</td>
                            <td>1100.00</td>
                          </tr>
                          <tr>
                            <td>Development</td>
                            <td>850.00</td>
                            <td>850.00</td>
                            <td>850.00</td>
                            <td>1000.00</td>
                          </tr>
                          <tr>
                            <td>Computer</td>
                            <td>850.00</td>
                            <td>850.00</td>
                            <td>-</td>
                            <td>-</td>
                          </tr>
                          <tr>
                            <td>Science Fees</td>
                            <td>-</td>
                            <td>650.00</td>
                            <td>650.00</td>
                            <td>-</td>
                          </tr>
                          <tr>
                            <th>TOTAL</th>
                            <th>5,500.00</th>
                            <th>6,150.00</th>
                            <th>5,300.00</th>
                            <th>4,800.00</th>
                          </tr>
                        </tbody>
                   </table>
                     </div>
                     <p><b> NOTE :</b> “The school reserves the right to increase the fees at any time of the year if any increment is considered necessary, and every year 10-15% tuition fees will be raised, to meet the yearly increment of the salaries & allowances.</p>
                     <ul className="list">
                     <li> Fees should be paid from 5th to the 20th of the month in cash unless specified, otherwise a fine of Rs. 50/- will be charged the next month. Fees for the month of March should be paid in February, as specified  </li>
                      <li> The School fees cover twelve calendar months. No exception is made for holidays or broken periods Students are liable to be charged full fees as long as their names are officially on the rolls.  </li>
                      <li> Students whose fees have not been paid for three consecutive months, after due notification by the school will have their names struck off the rolls. If, however, they wish to continue their schooling they will be treated as new candidates needing readmission. The fees for the month of March must be paid by 20th February. Defaulters will be debarred from the final examination.  
                     Any re-issue of Calendar, Fee Book or Identity Card will be charged at these rates.
                       <p> Calender - Rs.150 <br/>
                     Fee Book - Rs.50 </p> </li>
                      <li> Annual Fees is to be paid by May otherwise a fine of Rs 50/- will be charged  </li>
                  </ul>
                     </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default Fees

